module.exports = __webpack_public_path__ + "console/img/天天.73490d11.jpg";